import * as types from "../actions/actionTypes";
import { getAllCommentsResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const commentEntity = createEntitySagas({
  entity: "comment",
  endpoint: "comments",
  label: "Comment",
  scope: "none",
  selectSlice: (state) => state.comment,
  listKey: "comments",
  types: { getAll: types.GET_ALL_COMMENTS, create: types.CREATE_COMMENT, remove: types.DELETE_COMMENT },
  actions: { getAllResponse: getAllCommentsResponse },
});

export const commentSaga = commentEntity.watcher;

